import { render, staticRenderFns } from "./CentersList.vue?vue&type=template&id=89914b3c&scoped=true"
import script from "./CentersList.vue?vue&type=script&lang=js"
export * from "./CentersList.vue?vue&type=script&lang=js"
import style0 from "./CentersList.vue?vue&type=style&index=0&id=89914b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89914b3c",
  null
  
)

export default component.exports